export const translations = {
    en: {
      newSearch: "New Search",
      history: "History",
      results: "Results",
      answer: "Answer",
      askMedicalQuestion: "Ask any medical question...",
      noResults: "No results found for your query. Please try a different query or check your spelling.",
      error: "An error occurred while processing this query.",
      loadingResults: "Loading results...",
      generatingAnswer: "Generating answer...",
      signOutText: "Are you sure you want to sign out?",
      plansText: "Plans",
      signOutConfirmText: "Yes, Sign Out",
      cancelGenericText: "Cancel",
      confirmGenericText: "Confirm",
      historyDeleteThreadText: "Are you sure you want to delete this search thread?",
      historyNoHistory: "No search history",
      askFollowUp:"Ask a follow-up question...",
      searchTypeLeftText: "Remaining: ",
      searchTypeMoreText: "You will have more in 24 hours",
      basic: "Basic",
      advanced: "Advanced",
      professional: "Professional"
    },
    fr: {
      newSearch: "Nouvelle recherche",
      history: "Historique",
      results: "Résultats",
      answer: "Réponse",
      askMedicalQuestion: "Posez une question médicale...",
      noResults: "Aucun résultat trouvé pour votre requête. Veuillez essayer une autre requête ou vérifier l'orthographe.",
      error: "Une erreur s'est produite lors du traitement de cette requête.",
      loadingResults: "Chargement des résultats...",
      generatingAnswer: "Génération de la réponse...",
      signOutText: "Êtes-vous sûr de vouloir vous déconnecter ?",
      plansText: "Plans",
      signOutConfirmText: "Oui, Déconnexion",
      cancelGenericText: "Annuler",
      confirmGenericText: "Confirmer",
      historyDeleteThreadText: "Êtes-vous sûr de vouloir supprimer ce fil de recherche ?",
      historyNoHistory: "Aucun historique de recherche",
      askFollowUp:"Poser une question complémentaire...",
      searchTypeLeftText: "Restant: ",
      searchTypeMoreText: "Vous en aurez plus dans 24 heures",
      basic: "Basique",
      advanced: "Avancé",
      professional: "Professionnel"
    },
    es: {
      newSearch: "Nueva búsqueda",
      history: "Historial",
      results: "Resultados",
      answer: "Respuesta",
      askMedicalQuestion: "Haga cualquier pregunta médica...",
      noResults: "No se encontraron resultados para su consulta. Intente con una consulta diferente o verifique la ortografía.",
      error: "Se produjo un error al procesar esta consulta.",
      loadingResults: "Cargando resultados...",
      generatingAnswer: "Generando respuesta...",
      signOutText: "¿Estás seguro de que quieres cerrar sesión?",
      plansText: "Planes",
      signOutConfirmText: "Sí, Cerrar sesión",
      cancelGenericText: "Cancelar",
      confirmGenericText: "Confirmar",
      historyDeleteThreadText: "¿Estás seguro de que quieres eliminar este hilo de búsqueda?",
      historyNoHistory: "Sin historial de búsqueda",
      askFollowUp:"Haz una pregunta de seguimiento...",
      searchTypeLeftText: "Restante: ",
      searchTypeMoreText: "Tendrás más en 24 horas",
      basic: "Básico",
      advanced: "Avanzado",
      professional: "Profesional"
    },
    de: {
      newSearch: "Neue Suche",
      history: "Verlauf",
      results: "Ergebnisse",
      answer: "Antwort",
      askMedicalQuestion: "Stellen Sie eine medizinische Frage...",
      noResults: "Keine Ergebnisse für Ihre Anfrage gefunden. Bitte versuchen Sie eine andere Anfrage oder überprüfen Sie die Rechtschreibung.",
      error: "Bei der Verarbeitung dieser Anfrage ist ein Fehler aufgetreten.",
      loadingResults: "Ergebnisse werden geladen...",
      generatingAnswer: "Antwort wird generiert...",
      signOutText: "Sind Sie sicher, dass Sie sich abmelden möchten?",
      plansText: "Pläne",
      signOutConfirmText: "Ja, Abmelden",
      cancelGenericText: "Abbrechen",
      confirmGenericText: "Bestätigen",
      historyDeleteThreadText: "Möchten Sie diesen Suchthread wirklich löschen?",
      historyNoHistory: "Keine Suchhistorie",
      askFollowUp:"Stellen Sie eine Folgefrage …",
      searchTypeLeftText: "Verbleibend: ",
      searchTypeMoreText: "Sie werden in 24 Stunden mehr haben",
      basic: "Basis",
      advanced: "Fortgeschritten",
      professional: "Professionell"
    },
    el: {
      newSearch: "Νέα αναζήτηση",
      history: "Ιστορικό",
      results: "Αποτελέσματα",
      answer: "Απάντηση",
      askMedicalQuestion: "Κάντε οποιαδήποτε ιατρική ερώτηση...",
      noResults: "Δεν βρέθηκαν αποτελέσματα για το ερώτημά σας. Δοκιμάστε μια διαφορετική ερώτηση ή ελέγξτε την ορθογραφία.",
      error: "Παρουσιάστηκε σφάλμα κατά την επεξεργασία αυτού του ερωτήματος.",
      loadingResults: "Φόρτωση αποτελεσμάτων...",
      generatingAnswer: "Δημιουργία απάντησης...",
      signOutText: "Είστε σίγουροι ότι θέλετε να αποσυνδεθείτε;",
      plansText: "Σχέδια",
      signOutConfirmText: "Ναι, Αποσύνδεση",
      cancelGenericText: "Ακύρωση",
      confirmGenericText: "Επιβεβαίωση",
      historyDeleteThreadText: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το νήμα αναζήτησης;",
      historyNoHistory: "Δεν υπάρχει ιστορικό αναζήτησης",
      askFollowUp:"Κάντε μια επόμενη ερώτηση...",
      searchTypeLeftText: "Υπολειπόμενο: ",
      searchTypeMoreText: "Θα έχετε περισσότερα σε 24 ώρες",
      basic: "Βασικό",
      advanced: "Προχωρημένο",
      professional: "Επαγγελματικό"
    },
    pl: {
      newSearch: "Nowe wyszukiwanie",
      history: "Historia",
      results: "Wyniki",
      answer: "Odpowiedź",
      askMedicalQuestion: "Zadaj dowolne pytanie medyczne...",
      noResults: "Nie znaleziono wyników dla twojego zapytania. Spróbuj innego zapytania lub sprawdź pisownię.",
      error: "Wystąpił błąd podczas przetwarzania tego zapytania.",
      loadingResults: "Wyniki są ładowane...",
      generatingAnswer: "Odpowiedź jest generowana...",
      signOutText: "Czy na pewno chcesz się wylogować?",
      plansText: "Plany",
      signOutConfirmText: "Tak, Wyloguj się",
      cancelGenericText: "Anuluj",
      confirmGenericText: "Potwierdź",
      historyDeleteThreadText: "Czy na pewno chcesz usunąć ten wątek wyszukiwania?",
      historyNoHistory: "Brak historii wyszukiwania",
      askFollowUp:"Zadaj pytanie dodatkowe...",
      searchTypeLeftText: "Pozostały: ",
      searchTypeMoreText: "Będziesz mieć więcej za 24 godziny",
      basic: "Podstawowy",
      advanced: "Zaawansowany",
      professional: "Profesjonalny"
    },
    ro: {
      newSearch: "Căutare nouă",
      history: "Istoric",
      results: "Rezultate",
      answer: "Răspuns",
      askMedicalQuestion: "Puneți orice întrebare medicală...",
      noResults: "Nu s-au găsit rezultate pentru interogarea dvs. Încercați o interogare diferită sau verificați ortografia.",
      error: "A apărut o eroare la procesarea acestei interogări.",
      loadingResults: "Rezultatele sunt încărcate...",
      generatingAnswer: "Răspunsul este generat...",
      signOutText: "Sunteți sigur că doriți să vă deconectați?",
      plansText: "Planuri",
      signOutConfirmText: "Da, Deconectare",
      cancelGenericText: "Anulare",
      confirmGenericText: "Confirma",
      historyDeleteThreadText: "Sunteți sigur că doriți să ștergeți acesta căutare?",
      historyNoHistory: "Fără istoric de căutare",
      askFollowUp:"Pune o întrebare ulterioară...",
      searchTypeLeftText: "Rămas: ",
      searchTypeMoreText: "Vei avea mai mult în 24 de ore",
      basic: "De bază",
      advanced: "Avansat",
      professional: "Profesional"
    },
    hu: {
      newSearch: "Új keresés",
      history: "Előzmények",
      results: "Eredmények",
      answer: "Válasz",
      askMedicalQuestion: "Tegyen fel bármilyen orvosi kérdést...",
      noResults: "Nem található eredmény a keresésre. Kérjük, próbálkozzon más kereséssel vagy ellenőrizze a helyesírást.",
      error: "Hiba történt a lekérdezés feldolgozása során.",
      loadingResults: "Eredmények betöltése...",
      generatingAnswer: "Válasz generálása...",
      signOutText: "Biztosan ki szeretnél jelentkezni?",
      plansText: "Tervek",
      signOutConfirmText: "Igen, Kijelentkezés",
      cancelGenericText: "Mégsemz",
      confirmGenericText: "Megerősít",
      historyDeleteThreadText: "Biztosan törli ezt a keresési szálat?",
      historyNoHistory: "Nincs keresési előzmény",
      askFollowUp:"Tegyen fel egy további kérdést...",
      searchTypeLeftText: "Hátralévő: ",
      searchTypeMoreText: "Több lesz 24 óra múlva",
      basic: "Alap",
      advanced: "Haladó",
      professional: "Professzionális"
    },
    bg: {
      newSearch: "Ново търсене",
      history: "История",
      results: "Резултати",
      answer: "Отговор",
      askMedicalQuestion: "Задайте какъвто и да е медицински въпрос...",
      noResults: "Не са намерени резултати за вашето запитване. Моля, опитайте с друго запитване или проверете правописа.",
      error: "Възникна грешка при обработката на това запитване.",
      loadingResults: "Резултатите се зареждат...",
      generatingAnswer: "Отговора се генерира...",
      signOutText: "Сигурни ли сте, че искате да излезете?",
      plansText: "Планове",
      signOutConfirmText: "Да, Изход",
      cancelGenericText: "Отмени",
      confirmGenericText: "Потвърждавам",
      historyDeleteThreadText: "Сигурни ли сте, че искате да изтриете тази нишка за търсене?",
      historyNoHistory: "Няма история на търсенето",
      askFollowUp:"Задайте допълнителен въпрос...",
      searchTypeLeftText: "Оставащ: ",
      searchTypeMoreText: "Ще имате повече след 24 часа",
      basic: "Основен",
      advanced: "Разширен",
      professional: "Професионален"
    },
    hr: {
      newSearch: "Novo pretraživanje",
      history: "Povijest",
      results: "Rezultati",
      answer: "Odgovor",
      askMedicalQuestion: "Postavite bilo koje medicinsko pitanje...",
      noResults: "Nisu pronađeni rezultati za vaš upit. Molimo pokušajte s drugim upitom ili provjerite pravopis.",
      error: "Došlo je do pogreške prilikom obrade ovog upita.",
      loadingResults: "Rezultati se učitavaju...",
      generatingAnswer: "Odgovor se generira...",
      signOutText: "Jeste li sigurni da želite izaći?",
      plansText: "Planovi",
      signOutConfirmText: "Da, Izlazak",
      cancelGenericText: "Odustani",
      confirmGenericText: "Potvrdi",
      historyDeleteThreadText: "Jeste li sigurni da želite izbrisati ovu nit pretraživanja?",
      historyNoHistory: "Nema povijesti pretraživanja",
      askFollowUp:"Postavite dodatno pitanje...",
      searchTypeLeftText: "Preostalo: ",
      searchTypeMoreText: "Imat ćete više za 24 sata",
      basic: "Osnovno",
      advanced: "Napredno",
      professional: "Profesionalno"
    },
    ar: {
      newSearch: "بحث جديد",
      history: "السجل",
      results: "النتائج",
      answer: "الإجابة",
      askMedicalQuestion: "اسأل أي سؤال طبي...",
      noResults: "لم يتم العثور على نتائج لاستعلامك. يرجى تجربة استعلام مختلف أو التحقق من الإملاء.",
      error: "حدث خطأ أثناء معالجة هذا الاستعلام.",
      loadingResults: "تحميل النتائج...",
      generatingAnswer: "إنشاء الإجابة...",
      signOutText: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
      plansText: "خطط ",
      signOutConfirmText: " نعم، تسجيل الخروج",
      cancelGenericText: "إلغاء",
      confirmGenericText: "تأكيد",
      historyDeleteThreadText: "هل أنت متأكد أنك تريد حذف موضوع البحث هذا؟",
      historyNoHistory: "لا يوجد تاريخ بحث",
      askFollowUp: "اطرح سؤالا متابعة...",
      searchTypeLeftText: "المتبقي: ",
      searchTypeMoreText: "ستحصل على المزيد في غضون 24 ساعة",
      basic: "أساسي",
      advanced: "متقدم",
      professional: " احترافي "
    },
    ko: {
      newSearch: "새 검색", // Placeholder
      history: "기록", // Placeholder
      results: "결과", // Placeholder
      answer: "답변", // Placeholder
      askMedicalQuestion: "의학 관련 질문을 하세요...", // Placeholder
      noResults: "쿼리에 대한 결과가 없습니다. 다른 쿼리를 시도하거나 철자를 확인하십시오.", // Placeholder
      error: "이 쿼리를 처리하는 동안 오류가 발생했습니다.", // Placeholder
      loadingResults: "결과를 로드하는 중...", // Placeholder
      generatingAnswer: "답변 생성 중...", // Placeholder
      signOutText: "로그아웃하시겠습니까?", // Placeholder
      plansText: "요금제", // Placeholder
      signOutConfirmText: "예, 로그아웃합니다", // Placeholder
      cancelGenericText: "취소", // Placeholder
      confirmGenericText: "확인", // Placeholder
      historyDeleteThreadText: "이 검색 스레드를 삭제하시겠습니까?", // Placeholder
      historyNoHistory: "검색 기록 없음", // Placeholder
      askFollowUp:"후속 질문을 하세요...", // Placeholder
      searchTypeLeftText: "남은 검색: ", // Placeholder
      searchTypeMoreText: "24시간 후에 더 많은 검색이 가능합니다", // Placeholder
      basic: "기본", // Placeholder
      advanced: "고급", // Placeholder
      professional: "전문가" // Placeholder
    }
  };